import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { Questions } from './scenes/Questions'
import { PerfectProduct } from './scenes/PerfectProduct'
import { NoResults } from './scenes/NoResults'

export const ProductSelector =() => {
  return (
    <PublicLayout className='general-content product-selector'>
      <Switch>
        <Route
          path='/product-selector'
          component={Questions}
          exact
        />

        <Route
          path='/product-selector/results/:brand/:leakage/:sku'
          component={PerfectProduct}
        />

        <Route
          path='/product-selector/no-results'
          component={NoResults}
        />

        <Redirect
          to='/product-selector'
        />
      </Switch>
    </PublicLayout>
  )
}
